/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useTranslation } from 'react-i18next';
import { TextInput } from '@wajeez-web/components/ui';
import { SearchIcon } from '@heroicons/react/solid';
import {
  SelectedColumnsFilters,
  TableFiltersProps,
  DateAndNumberComparisonValues,
  StringComparisonValues,
  OtherComparisonValues,
  Column,
} from './types';

const TableDefaultFilter: React.FC<TableFiltersProps> = ({
  columns,
  selectedColumnsFilters,
  setSelectedColumnsFilters,
  tableData,
}) => {
  const { t } = useTranslation();

  const handelSelect =
    (parentName: string | number | null, type: string, item: Column) =>
    (name: string, value: any) => {
      if (selectedColumnsFilters.find((item) => item.key === parentName)) {
        const selectedIndex: number = selectedColumnsFilters.findIndex(
          (element) => element.key === parentName
        );
        const cols: SelectedColumnsFilters[] = selectedColumnsFilters;
        selectedColumnsFilters[selectedIndex] = {
          ...selectedColumnsFilters[selectedIndex],
          value:
            type === 'Boolean'
              ? value.value === 'true'
                ? true
                : false
              : type === 'select'
              ? value
              : value,
        };
        setSelectedColumnsFilters(cols);
      } else {
        setSelectedColumnsFilters([
          ...selectedColumnsFilters,
          {
            label: item.label,
            key: item.key,
            value:
              type === 'Boolean'
                ? value.value === 'true'
                  ? true
                  : false
                : type === 'select'
                ? value
                : value,
            type: item.type,
            operator: item.operator,
          },
        ]);
      }
    };
  const getFilterComponent = (item: any) => {
    switch (item.type) {
      case 'String':
        return (
          <TextInput
            key={item.label}
            prefix={<SearchIcon className="w-4" />}
            shape="circle"
            onChange={handelSelect(item.key, 'text', item)}
            placeholder={`${t(`inputs.placeholders.${'Search by'}`)} ${
              item.label
            }`}
            name={item.key}
            value={
              selectedColumnsFilters.length
                ? selectedColumnsFilters.find((ele) => ele.key === item.key)
                    ?.value || ''
                : ''
            }
          />
        );
    }
    return <div></div>;
  };

  return (
    <div className="flex justify-center items-center space-s-2">
      {columns
        .filter((item) => item.dataType !== 'Image')
        .map((item) => ({
          label: item.header,
          key: item.id,
          operators:
            item.dataType === 'DateTime' || item.dataType === 'Number'
              ? DateAndNumberComparisonValues
              : item.dataType === 'String'
              ? StringComparisonValues
              : OtherComparisonValues,
          isPopular: tableData['defaultFilters'].find(
            (ele: { property: string | number }) => ele.property === item.id
          )
            ? true
            : false,
          isSelected: false,
          type: item.dataType,
          operator: { label: '', value: '2' },
        }))
        ?.filter((item) => item.isPopular)
        // @ts-ignore
        .map((item) => getFilterComponent(item))}
    </div>
  );
};

export default TableDefaultFilter;
